import { render } from "./TakeOutCollection.vue?vue&type=template&id=ee10008a&scoped=true"
import script from "./TakeOutCollection.vue?vue&type=script&lang=js"
export * from "./TakeOutCollection.vue?vue&type=script&lang=js"

import "./TakeOutCollection.vue?vue&type=style&index=0&id=ee10008a&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee10008a"]])

export default __exports__